"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emitTrackingEvent = (eventName, eventMetadata) => {
    var _a;
    if ((window === null || window === void 0 ? void 0 : window.analytics) && ((_a = window === null || window === void 0 ? void 0 : window.analytics) === null || _a === void 0 ? void 0 : _a.track)) {
        try {
            if (!eventMetadata) {
                return window.analytics.track(eventName);
            }
            return window.analytics.track(eventName, eventMetadata);
        }
        catch (err) {
            if (err) {
                return null;
            }
            return null;
        }
    }
    return null;
};
exports.default = emitTrackingEvent;
//# sourceMappingURL=emitTrackingEvent.js.map